import { render, staticRenderFns } from "./moreDNB.vue?vue&type=template&id=5528dc4c&lang=pug&"
import script from "./moreDNB.vue?vue&type=script&lang=js&"
export * from "./moreDNB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports